export * from './tags.component';
export * from './tags.module';
